import {
  ClaimedPlayerSummary,
  ClaimedPlayerResponse,
  TeamSummary,
  TeamRole,
} from '@features/Home/home.d';
import axios from '@helpers/axios';
// import * as Sentry from '@sentry/react';
import useSWR from 'swr';

const useHome = () => {
  const fetcher = (url: string) => axios.get(url).then((res) => res.data);
  const { data, error } = useSWR('/v2/home', fetcher);

  const loading = !data && !error;

  const lastViewed = localStorage.getItem('teamId');
  const filterAndSortTeamsByRole = (teams: TeamSummary[], role: TeamRole) => {
    return teams
      .filter((team) => team.roles.includes(role))
      .sort((a, b) => {
        if (a.id === lastViewed) {
          return -1;
        }
        if (b.id === lastViewed) {
          return 1;
        }
        if (a.nameLong < b.nameLong) {
          return -1;
        }
        if (a.nameLong > b.nameLong) {
          return 1;
        }
        return 0;
      });
  };

  const claimedPlayers: ClaimedPlayerSummary[] =
    data?.claimedPlayers.map((x: ClaimedPlayerResponse) => x) ||
    ([] as ClaimedPlayerSummary[]);

  const coachedTeams: TeamSummary[] =
    filterAndSortTeamsByRole(data?.teams || [], TeamRole.Coach) ||
    ([] as TeamSummary[]);

  const adminTeams: TeamSummary[] =
    filterAndSortTeamsByRole(data?.teams || [], TeamRole.Admin) ||
    ([] as TeamSummary[]);

  return {
    loading,
    error,
    claimedPlayers,
    coachedTeams,
    adminTeams,
  };
};

export default useHome;
